import './AppDetailsPopover.scss';

import { AppDisplay } from './AppDisplay';
import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { coreActions } from '@sonar-software/sonar-core';
import { DetailSubsection } from '@periscopes/general';
import { SonarStakeholder } from '@ui/SonarStakeholder';
import { SonarUser } from '@ui/SonarUser';
import { StakeholderAvatarGroup } from '@ui/avatar';

import { Popover, Space } from 'antd';
import React, { PropsWithChildren } from 'react';
import { useAction, useApplicationReference } from '@hooks';

export interface AppDetailsPopoverProps {
	appId: number;
}

export const AppDetailsPopover: React.FC<PropsWithChildren<AppDetailsPopoverProps>> = ({ appId, children }) => {
	const { description, integrationUser, ownerId, stakeholderGroupId, stakeholderIds } =
		useApplicationReference(appId);

	const loadApp = useAction(coreActions.requestGetCoreDataSecurityApplicationsById);

	const content =
		<>
			<DetailSubsection title={ COPY_SPECIFIC.NAME }>{ <AppDisplay appId={ appId } /> }</DetailSubsection>
			<DetailSubsection title={ COPY_SPECIFIC.INTEGRATION_USER }>{ integrationUser }</DetailSubsection>
			{ Boolean(description) &&
				<DetailSubsection
					className='app-description'
					title={ COPY_SPECIFIC.DESCRIPTION }>
					{ description }
				</DetailSubsection> }
			{ ownerId !== undefined && Boolean(ownerId) &&
				<DetailSubsection title={ COPY_SPECIFIC.OWNER }>
					<SonarUser
						showTooltip
						userId={ ownerId } />
				</DetailSubsection> }
			{ stakeholderIds !== undefined && Boolean(stakeholderIds.length) &&
				<DetailSubsection title={ COPY_SPECIFIC.STAKEHOLDERS }>
					<Space direction='vertical'>
						{ stakeholderIds.slice(0, 3).map((id) =>
							<SonarStakeholder
								key={ id }
								showTooltip
								stakeholderId={ id } />) }
						{ stakeholderIds.length > 3 &&
							<StakeholderAvatarGroup
								maxCount={ 5 }
								stakeholders={ stakeholderIds.slice(3).map((id) => ({ stakeholderId: id })) } /> }
					</Space>
				</DetailSubsection> }
			{ stakeholderGroupId !== undefined && Boolean(stakeholderGroupId) &&
				<DetailSubsection title={ COPY_SPECIFIC.GROUP }>
					<SonarStakeholder
						showTooltip
						stakeholderId={ stakeholderGroupId } />
				</DetailSubsection> }
		</>;

	return (
		<Popover
			classNames={ { root: 'app-details-popover' } }
			content={ content }
			onOpenChange={ (open) => {
				if (open && !integrationUser) {
					loadApp({ applicationId: appId });
				}
			} }
			placement='right'>
			{ children }
		</Popover>
	);
};
